import { ToastNotificationType } from '@modules/common/components/Notification/NotificationContext';
import { LeftOffset } from './types';

const POSITION_OFFSET = '20px';
const BOTTOM_OFFSET_DIFFERENCE = '70px';

export const getNotificationToastPositionValues = (
  notificationType: ToastNotificationType,
  notificationIndex: number,
  numberOfActiveNotifications: number,
  leftOffset?: LeftOffset,
) => {
  const bottomOffset = `calc(${POSITION_OFFSET} + ${
    numberOfActiveNotifications - notificationIndex - 1
  } * ${BOTTOM_OFFSET_DIFFERENCE})`;
  switch (notificationType) {
    case ToastNotificationType.InfoCard:
      return {
        bottom: bottomOffset,
        left: leftOffset ?? POSITION_OFFSET,
      };

    case ToastNotificationType.DefaultNotification:
    default:
      return {
        bottom: bottomOffset,
        left: leftOffset ?? '98px',
      };
  }
};
